import { IExpressionEvaluatorContext } from "@@expressions";
import { IContainerComponent } from "../Models/IContainerComponent";
import useObservedExpression from "./useObservedExpression";
import { useObservedExpressionResult } from "./useObservedExpressionResult";
import useRegisterViewController from "./useRegisterViewController";

const NULL_RESULT: useObservedExpressionResult<any> = [undefined, false, () => Promise.resolve(undefined)];

export default function useViewOnOpen(component: IContainerComponent, context: IExpressionEvaluatorContext, loggerName: string) {
  if (!component.OnOpen) {
    return NULL_RESULT;
  }

  // Note: These hooks are placed in this condition on purpoise to avoid unnecessary evaluation
  // The component definition WILL NOT change during the lifecycle of the component, so it's safe to call hooks conditionally based on its properties

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [onOpenResult, onOpenPending, onOpenRefresh] = useObservedExpression<any>(component.OnOpen, context, loggerName);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useRegisterViewController(component, context, onOpenRefresh);
  return [onOpenResult, onOpenPending, onOpenRefresh];
}
